module.exports = __webpack_public_path__ + "img/kazakhstan.8596323c.svg";